import styled from 'styled-components';
import { adminToken } from 'config/token';

export const BellWrap = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;

  .ant-badge-count {
    top: -10px;
    background: ${adminToken.badgeBackground};
    font-size: 15px;
    box-shadow: none;
  }
`;
